import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/safety/page.tsx");
